// extracted by mini-css-extract-plugin
export var numpadContainer = "_sr-1";
export var phoneButton = "_sr-0";